@if(loading){
<div class="loading">
  <app-spinner></app-spinner>
</div>
}
@if(!loading) {
<router-outlet></router-outlet>
}
